import settings from '@/settings'

let porPosto = (cnpj, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/?posto=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let porConvenio = (cnpj, convenio, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/porconvenio/?convenio=${convenio}&posto=${cnpj}`, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let inserirPorConvenio = (cnpj, data, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/porconvenio/?posto=${cnpj}`, {
    method: 'POST',
    mode: 'cors',
    cache: 'default',
    headers: headers,
    body: JSON.stringify(data)
  })
}

let inserir = (data, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

let cancelar = (data, headers) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/${data.id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers,
    body: JSON.stringify(data)
  })
}

let atualizar = (id, data, headers, posto) => {
  return fetch(`${settings.apetrusApi}/codigospromocionais/${id}/?posto=${posto}`, {
    method: 'PUT',
    mode: 'cors',
    cache: 'default',
    body: JSON.stringify(data),
    headers: headers
  })
}

export default {
  porPosto,
  porConvenio,
  inserirPorConvenio,
  inserir,
  cancelar,
  atualizar
}
